import React, { useRef, useState, useEffect } from "react";
import {
    GraphComponentContainer,
    ButtonHeader,
    RemoveWLButton,
    CloseComponentButton,
    StyledIconSlashButton,
    StyledIconButton,
    InputItemContainer,
    RegularText,
    CheckboxContainer,
    StyledCheckbox,
    FormH1,
    CardContainer,
    LeftSection,
    StockHeader,
    StockSymbol,
    StockName,
    PriceContainer,
    CurrentPrice,
    PriceChange,
    DataGrid,
    DataRow,
    DataLabel,
    DataValue,
    RightSection,
    SectionTitle,
    ActionToggleGroup,
    ToggleButton,
    InputGroup,
    InputLabel,
    StyledInput,
    SubmitButton,
    RightHeaderContainer,
    RowGroup,
    FormSelectDropdownContainer,
    FormLabel,
    FormSelect,
    Option,
    ToggleWrapper,
    HeaderWrapper,
    Divider
} from "./ChartElements";
import StockDetails from "../StockDetailsForms";

const ChartStation = ({ handleRemoveWatchlist, handleClearWatchlistStock, handleOnCheck, currentWatchlistStock, watchlist_stock, stock_data, token, selectedAccount, handleStockTarget }) => {

    const [hasChanged, setHasChanged] = useState(false);
    const [hasValueChanged, setHasValueChanged] = useState(false);
    const [targetType, setTargetType] = useState(watchlist_stock?.limit ? watchlist_stock?.limit.unit : 'percent')
    const [targetInvestment, setTargetInvestment] = useState(watchlist_stock?.limit ? watchlist_stock?.limit.value : null);
    const [open, setOpen] = useState(null);
    const [close, setClose] = useState(null);
    const [high, setHigh] = useState(null);
    const [low, setLow] = useState(null);
    const [volume, setVolume] = useState(null);
    const [ind, setInd] = useState("D");

    useEffect(() => {
        if (watchlist_stock?.limit) {
            setTargetInvestment(watchlist_stock?.limit.value);
            setTargetType(watchlist_stock?.limit.unit);
        }
        else {
            setTargetInvestment("null");
        }
        setHasChanged(false);
        setHasValueChanged(false);
    }, [watchlist_stock]);

    useEffect(() => {
        if (stock_data) {
            setOpen(stock_data.open);
            setClose(stock_data.close);
            setHigh(stock_data.high);
            setLow(stock_data.low);
            setVolume(stock_data.volume);
        }
    }, [stock_data]);

    const handleSetTargetInvestment = (e) => {
        e.preventDefault();
        const val = e.target.value;

        if (val === '') {
            setTargetInvestment('');
            setHasChanged(false)
            return;
        }

        const onlyNumbers = val.replace(/[^0-9]/g, '');

        if (val !== onlyNumbers) return;

        const numVal = Number(onlyNumbers);
        if (numVal <= 0) return;
        if (targetType === 'percent' && numVal >= 100) return;

        setTargetInvestment(onlyNumbers);
        setHasChanged(onlyNumbers != watchlist_stock?.limit?.value);
        setHasValueChanged(onlyNumbers != watchlist_stock?.limit?.value);
    };

    const handleSetTargetType = (e) => {
        e.preventDefault();
        const check = watchlist_stock?.limit ? watchlist_stock?.limit?.unit === e.target.value : targetType === e.target.value
        if (!check) {
            setTargetType(e.target.value);
            setHasChanged(true);
        }
        else {
            if (hasChanged && !hasValueChanged) setHasChanged(false);
        }
    }
    const timeframeInd = {
        D: 0,
        M: 1,
        '3M': 2,
        YTD: 3
    };

    const options = ['D', 'M', '3M', 'YTD'];

    const handleSetTimeframe = (e, opt) => {
        e.preventDefault();
        setInd(opt)
    }
    return (
        <GraphComponentContainer>
            {open ?
                <CardContainer>
                    <LeftSection>
                        <HeaderWrapper>
                            <StockHeader>
                                <StockSymbol>{currentWatchlistStock.currentStock}</StockSymbol>
                                <StockName>{stock_data.title}</StockName>
                            </StockHeader>
                            <ToggleWrapper>
                                {options.map((opt, index) => (
                                    <>
                                        <Option isActive={ind === opt} onClick={(e) => handleSetTimeframe(e, opt)}> {opt}</Option>
                                        {index < options.length - 1 && <Divider>|</Divider>}
                                    </>
                                ))}
                            </ToggleWrapper>
                        </HeaderWrapper>

                        <PriceContainer>
                            <CurrentPrice>${close["D"]?.toFixed(2)}</CurrentPrice>
                            <PriceChange isPositive={open ? open[ind] < close["D"] : true}>
                                {open[ind] < close["D"] ? '+' : '-'}${Math.abs(close["D"] - open[ind]).toFixed(2)} ({Math.abs(((close["D"] - open[ind]) / open[ind]) * 100).toFixed(2)}%)
                            </PriceChange>
                        </PriceContainer>

                        <DataGrid>
                            <DataRow>
                                <DataLabel>Open</DataLabel>
                                <DataValue>${open[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>High</DataLabel>
                                <DataValue>${high[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>Volume</DataLabel>
                                <DataValue>{(volume[ind] / 1000000)?.toFixed(1)}M</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>Low</DataLabel>
                                <DataValue>${low[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                        </DataGrid>
                    </LeftSection>
                    <RightSection>
                        <form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <div>

                                <RightHeaderContainer>
                                    <SectionTitle>Trade Settings</SectionTitle>
                                    <ButtonHeader>
                                        <RemoveWLButton onClick={(e) => handleRemoveWatchlist(e, selectedAccount)} />
                                        <CloseComponentButton onClick={(e) => handleClearWatchlistStock(e)} />
                                    </ButtonHeader>
                                </RightHeaderContainer>
                                <ActionToggleGroup>
                                    <ToggleButton
                                        type="button"
                                        active={watchlist_stock?.buy}
                                        action="buy"
                                        onClick={(e) => handleOnCheck(e, currentWatchlistStock.id, currentWatchlistStock.currentStock, 'buy')}
                                    >
                                        Buy
                                    </ToggleButton>
                                    <ToggleButton
                                        type="button"
                                        active={watchlist_stock?.sell}
                                        action="sell"
                                        onClick={(e) => handleOnCheck(e, currentWatchlistStock.id, currentWatchlistStock.currentStock, 'sell')}
                                    >
                                        Sell
                                    </ToggleButton>
                                </ActionToggleGroup>

                                <InputGroup>
                                    <InputLabel htmlFor="targetInvestment" title="Target value that Lay Trader will trend to overtime">Target Investment</InputLabel>
                                    <RowGroup>
                                        <StyledInput
                                            id="targetInvestment"
                                            type="number"
                                            placeholder="e.g. 50"
                                            value={targetInvestment}
                                            onChange={(e) => handleSetTargetInvestment(e)}
                                        />
                                        <FormSelectDropdownContainer>
                                            {<FormSelect id="type_select" onChange={(e) => handleSetTargetType(e)}>
                                                {/* <option value="" disabled selected hidden></option> */}
                                                <option value={"percent"} selected={targetType === 'percent'} title="Percent of Account">
                                                    %
                                                </option>
                                                <option value={"dollars"} selected={targetType === 'dollars'} title="Dollar Value">
                                                    $
                                                </option>
                                                <option value={"shares"} selected={targetType === 'shares'} title="Number of Shares">
                                                    #
                                                </option>
                                            </FormSelect>}
                                        </FormSelectDropdownContainer>
                                    </RowGroup>
                                    <SubmitButton
                                        active={hasChanged}
                                        onClick={(e) => handleStockTarget(e, currentWatchlistStock.id, currentWatchlistStock.currentStock, { unit: targetType ? targetType : 'percent', value: parseFloat(targetInvestment) })}
                                    >
                                        Submit Target
                                    </SubmitButton>
                                </InputGroup>
                            </div>
                        </form>
                    </RightSection>
                </CardContainer > :
                <></>
            }

            <StockDetails token={token} ticker={[currentWatchlistStock.currentStock]} selectedAccount={selectedAccount} />
        </GraphComponentContainer >
    );
};

export default ChartStation;